/*

    Шапка с названием сайта
*/

import React from 'react';

import './KeyBoardShort.css';
import unique from '../modules/unique';



function KeyBoardShort(props) {
 

    const alphabet = "АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ";


  return (      

    <>
          <div className="container-fluid my-keyboard">
            { getKeys() }
          </div>
    </>
  );


    function getKeys()
  {
      let keys = [];
      let key_tmp = [];
      let key_in_row = 11;
      for(let i = 0; i < alphabet.length; i++)
      {
          if(i > 0 && (i % key_in_row == 0))
          {
              keys.push(<div key={unique()} className="row">{ key_tmp }</div>);
              key_tmp = [];
          }
          key_tmp.push(getOneKey(alphabet[i]));
      }

      if(key_tmp.length > 0) keys.push(<div key={unique()} className="row">{ key_tmp }</div>);

      return keys;
  }
  function getOneKey(simbol)
  {
      return <div key={ unique() } className="col one-key" onClick={(e) => ClickSimbol(e, simbol.toLowerCase())}>{simbol}</div>
  }


  function ClickSimbol(obj, simbol)
  {
      let bg = obj.target.style.backgroundColor;
      obj.target.style.backgroundColor = '#341067';
      setTimeout(() => { obj.target.style.backgroundColor = bg; props.onKeyboardClick(simbol); }, 100);    
  }

}

export default KeyBoardShort;
